import { BrowserRouter, Routes , Route } from "react-router-dom";
import Projects from "./components/Projects";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Gallery from "./components/Gallery";
import Services from "./components/Services";
import Footer from "./components/Footer";
import About from "./components/About";
import "./App.css"
import WhyUs from "./components/WhyUs";
import Contact from "./components/Contact";
import ScrollToTop from "./components/ScrollToTop";
import Stones from "./components/Stones";


function Home(){
return (
  <>
  <Hero/>
  <Services/>
  <Gallery/>
  <WhyUs/>

  </>
)
}


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
    <Navbar/>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<About/>} />
        <Route path="/projeler" element={<Projects/>} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/taslar" element={<Stones />} />
    </Routes>
    <Footer/>
    </BrowserRouter>
  );
}

export default App;